<template>
  <div :class="getClass">
    <input
      :id="id"
      v-model="model"
      :value="value"
      :class="[{'form-check-input': !button}, {'btn-check': button}]"
      type="checkbox"
      :role="role"
      :disabled="disabled"
      :required="required"
      autocomplete="off"
      style="cursor: pointer"
    />
    <label
      :for="id"
      :class="[
        {'form-check-label': !button},
        {
          'btn btn-outline-primary btn-sm d-inline-flex align-items-center justify-content-center':
            button,
        },
        {'text-nowrap': !allowWrap},
      ]"
    >
      {{ label }}
      <Icon v-if="button && icon" :icon="icon" :inline="true" />
    </label>
  </div>
</template>
<script lang="ts" setup>
import {type BootstrapCheckProps} from '@/components/shared/bootstrap/forms/BootstrapCheck/BootstrapCheck.types';
const model = defineModel<any>({required: true});
const {
  value = undefined,
  icon = undefined,
  label = undefined,
  allowWrap = false,
  disabled = false,
  required = false,
  inline = false,
  role = undefined,
  button = false,
} = defineProps<BootstrapCheckProps>();
const getClass = computed(() => {
  if (button === false)
    return ['form-check', {'form-check-inline': inline}, {'form-switch': role === 'switch'}];
});
if (button && label === undefined) console.warn('Checkbox toggle buttons require a label');
</script>
<style lang="scss" scoped>
.form-check > * {
  cursor: pointer;
}
</style>
